import { getDefaultExportFromCjs as r } from "../../../../_virtual/_commonjsHelpers.mjs";
import { exports as t, __module as o } from "../../../../_virtual/PlayerStates.mjs";
(function(a, e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = {
    BUFFERING: 3,
    ENDED: 0,
    PAUSED: 2,
    PLAYING: 1,
    UNSTARTED: -1,
    VIDEO_CUED: 5
  }, a.exports = e.default;
})(o, t);
const u = /* @__PURE__ */ r(t);
export {
  u as default
};
//# sourceMappingURL=PlayerStates.mjs.map
